module.exports = __webpack_public_path__ + "img/ng_fluent_filteron_20_regular.2743d30f.svg";